// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3848":"01fab7be7609f2f9","9173":"a60f37032b6a7277"}[chunkId] + ".css";
};